module.exports = __webpack_public_path__ + "static/img/10.7ae611c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/10.png
// module id = VAEp
// module chunks = 0